<template>
  <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" class="mediaModal">
    <div class="content">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card class="overflow-y-auto" style="max-height: 80vh">
            <md-card-header data-background-color="secondary">
              <h4 class="title">Sydney Markets Survey</h4>
            </md-card-header>
            <md-card-content>
              <survey-form />
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </md-dialog>
</template>

<script>
import ApiService from "@/services/api";
import SurveyForm from "../Forms/SurveyForm.vue";

export default {
  components: {
    SurveyForm
  },
  data() {
    return {
      showDialog: false
    };
  },
  watch: {
    $route: {
      deep: true,
      handler(to, from) {
        this.handleDialog();
      }
    },
    "$store.getters.authUser.survey_complete": function () {
      this.handleDialog();
    }
  },
  created() {
    ApiService.auth.setCSRF();

    this.handleDialog();
  },
  methods: {
    handleDialog() {
      //Remove return to show the survery
      return;

      const parent = this.$route.matched[this.$route.matched.length - 2];

      if (parent.redirect !== "/dashboard") return;
      if (this.$store.getters.authUser.survey_complete) {
        this.showDialog = false;
        return;
      }

      this.showDialog = true;
    }
  }
};
</script>
